import Controller from "./application_controller"

/**
 * Needs to keep track of modals in order of appearance
 * Needs to tell modals what their stacking order is, so they can animate & position themselves correctly
 * Needs to fix the application wrapper, adjust its offsetPosition to the current scroll position, and hide overflow
 * Once all modals are closed, restore the application wrapper to its original state
 */
export default class extends Controller {
  static identifier = "modal-page"
  static targets = ["application", "container", "modal"]

  modalTargetConnected(modal) {
    console.log("modalTargetConnected", modal)
    if (modal.parentElement !== this.containerTarget) {
      this.containerTarget.appendChild(modal)
    }

    this.updateModalOffsets()
    modal.showModal()
  }

  modalTargetDisconnected(modal) {
    console.log("modalTargetDisconnected", modal)
    this.updateModalOffsets()
  }

  updateModalOffsets() {
    this.modalTargets.forEach((m, index) => {
      m.style.setProperty('--modal-offset', `${this.modalTargets.length - index - 1}`)
    })
  }
}
